import { BillSchema } from "@src/sudozi-schemas/bill-schema";
import { ErpVendorPaymentInformationSchema } from "@src/sudozi-schemas/erp-vendor-payment-information-schema";
import { z } from "zod";

export const BillPaymentSchema = z.object({
  id: z.string(),
  billId: z.string(),
  createdAt: z.preprocess(
    (val) => (val instanceof Date ? val.toISOString() : val),
    z.string().datetime(),
  ),
  updatedAt: z.preprocess(
    (val) => (val instanceof Date ? val.toISOString() : val),
    z.string().datetime(),
  ),
  accountHolderName: z.string(),
  accountHolderType: z.enum(["COMPANY", "INDIVIDUAL"]),
  accountNumber: z.string(),
  routingNumber: z.string(),
  remittanceEmail: z.string().nullable(),
  email: z.string(),
  address1: z.string(),
  address2: z.string().nullable(),
  city: z.string(),
  state: z.string(),
  postalCode: z.string(),
  country: z.string(),
  paymentMethodId: z.string().nullable(),
  outboundPaymentFailReason: z.string().nullable(),
  expectedArrivalDate: z.preprocess(
    (val) => (val instanceof Date ? val.toISOString() : val),
    z.string().datetime().nullable(),
  ),
  completedAt: z.preprocess(
    (val) => (val instanceof Date ? val.toISOString() : val),
    z.string().datetime().nullable(),
  ),
  status: z.enum([
    "PAID",
    "PAID_OUTSIDE",
    "PENDING",
    "PROCESSING",
    "FAILED",
    "CANCELLED",
    "RETURNED",
  ]),
  paidAt: z.preprocess(
    (val) => (val instanceof Date ? val.toISOString() : val),
    z.string().datetime().nullable(),
  ),
  erpVendorPaymentInformation: ErpVendorPaymentInformationSchema.nullable(),
  vendorCompanyInvitations: z.array(
    z.object({
      id: z.string(),
      status: z.enum(["PENDING", "ACCEPTED", "REJECTED", "CANCELLED"]),
      toUser: z.object({
        id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        email: z.string(),
      }),
      fromUser: z.object({
        id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        email: z.string(),
      }),
      message: z.string().nullish(),
    }),
  ),
  paymentTransferEvents: z.array(
    z.object({
      id: z.string(),
      createdAt: z.preprocess(
        (val) => (val instanceof Date ? val.toISOString() : val),
        z.string().datetime(),
      ),
      eventType: z.string(),
      eventBody: z.string(),
    }),
  ),
  bill: BillSchema,
});
